import styled from "styled-components";

export const ScrollUpButton = styled.div`
  position: fixed;
  left: 190px;
  bottom: 40px;
  font-size: 18px;
  font-weight: 400;
  > i {
    margin-left: 10px;
  }
`;
